/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import { useState } from "react";
import {service as ContextNodeService} from "../Services/ContextNodeService";
import {useEffectPromise} from "./EffectHooks";

export const useFetchContextNode = (contextNodeId = null, bootstrappedContextNode = null) => {
	const [contextNodeModel, setContextNodeModel] = useState(bootstrappedContextNode);

	// factors that affect reloading
	const expectedContextNodeId = bootstrappedContextNode?.contextNodeId ?? contextNodeId;
	const contextNodeModelDoesntMatchContextNodeIdProp = (contextNodeModel == null) || Number(contextNodeModel.contextNodeId) !== Number(expectedContextNodeId);

	// conditions upon which we should reload the ContextNode
	const shouldFetchModel = (
		expectedContextNodeId && // there is something to fetch
		( !(contextNodeModel ?? bootstrappedContextNode) || contextNodeModelDoesntMatchContextNodeIdProp) // the contextNodeProp changed
	);

	useEffectPromise(
		async () => (await ContextNodeService.FindById(expectedContextNodeId))?.result,
		setContextNodeModel,
		[shouldFetchModel, expectedContextNodeId],
		shouldFetchModel
	);

	return contextNodeModel ?? bootstrappedContextNode;
};

export const useProjectContextNodeLookup = (lookup) => {
	const [project, setProject] = useState(null);

	useEffectPromise(
		async () => (await ContextNodeService.Lookup(lookup))?.project,
		setProject,
		[JSON.stringify(lookup)],
		!!lookup
	);

	return project;
};
